import { fetchV1Users, createV1User } from "@/services/v1/userAPIService";

export default {
  state: {
    users: [],
    userPageSize: 5,
    totalUserCount: 0,
  },
  getters: {
    users: (state) => state.users,
    currentUserPageSize: (state) => state.userPageSize,
    totalUserCount: (state) => state.totalUserCount,
  },
  mutations: {
    SET_USERS(state, users) {
      state.users = users;
    },
    SET_USER_PAGE_SIZE(state, pageSize) {
      state.userPageSize = pageSize;
    },
    SET_TOTAL_USER_COUNT(state, count) {
      state.totalUserCount = count;
    },
  },
  actions: {
    async fetchUsers({ commit }, { page = 1, pageSize = 5 } = {}) {
      //   commit("SET_LOADING", true);
      try {
        const response = await fetchV1Users(page, pageSize);
        commit("SET_USERS", response.results);
        commit("SET_USER_PAGE_SIZE", pageSize);
        commit("SET_TOTAL_USER_COUNT", response.count);
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        // commit("SET_LOADING", false);
        console.log("finally...");
      }
    },
    async addUser({ commit }, user) {
      try {
        const response = await createV1User(user);
        if (response.error) {
          const errorMessages = [];
          errorMessages.push(response.message);
          commit("SET_ERROR", errorMessages);
          return { success: false, message: response.message };
        }
        return { success: true, data: response };
      } catch (error) {
        const errorMessages = [];
        for (const [key, value] of Object.entries(error.response.data)) {
          errorMessages.push(value[0]);
          console.log(`role create... ${key}: ${value}`);
        }
        commit("SET_ERROR", errorMessages);
        const message = error.response?.data?.message || "Failed to add user.";
        return { success: false, message };
      }
    },
  },
};
